<template>
    <div>
        <el-select
            v-model="value"
            @change="selectCosign"
            @focus="focusingSearch"
            filterable
            remote
            :placeholder="$t.__('common.actions.search')"
            :remote-method="remoteMethod"
            :loading="loading"
            :loading-text="$t.__('common.labels.loading')"
            popper-class="to-the-top"
            ref="select"
            class="wp-10"
        >
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.lastName"
                :value="item.id"
            >
                <div class="flex-row jc-space">
                    <span>{{ item.name }}</span>
                    <span>{{ item.email }}</span>
                </div>
            </el-option>
        </el-select>
    </div>
</template>

<script>
import AutocompleteRemoteInput from 'vcomponents/inputs/AutocompleteRemoteInput.vue';
import ContactsApi from 'api/contacts';

export default {
    props: {
        thirdid: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            value: '',
            loading: false,
            options: [],
            hasBeenFocused: false,
        };
    },
    events: {
        'cosign:alreadycosign': function () {
            this.value = null;
        },
    },
    methods: {
        selectCosign() {
            Esign.addCosign(this.options.find((opt) => opt.id === this.value));
            this.value = null;
            this.options = [];
        },
        remoteMethod: _.debounce(function (query) {
            this.options = [];
            this.loading = true;
            ContactsApi.autocompleteContact(query, this.thirdid)
                .then((response) => {
                    // Remove group of contact
                    this.options = response.filter((contact) => _.isNil(contact.children));
                })
                .catch((err) => {
                    Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                })
                .finally(() => {
                    this.loading = false;
                });
        }, 500),
        focusingSearch() {
            if (!this.hasBeenFocused) {
                this.hasBeenFocused = true;
                this.remoteMethod('');
            }
        },
    },
    components: {
        AutocompleteRemoteInput,
    },
};
</script>
<style lang="scss">
.to-the-top {
    z-index: 10000 !important;
}
</style>
